var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Clipboard',{attrs:{"clipboard-object":_vm.clipboard},on:{"save":_vm.onSave}})}
var staticRenderFns = []

export { render, staticRenderFns }